var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.$i18n.locale === "pe"
      ? _c("div", [
          _vm.$store.state.currentUser.user.rol !== "CLIENT"
            ? _c("div", { attrs: { id: "notPermissions" } }, [
                _c("p", [
                  _vm._v(
                    "Usted no tiene permisos para ver este menú. Consulte al equipo de desarrollo para más información."
                  ),
                ]),
              ])
            : _vm._e(),
        ])
      : _vm._e(),
    _vm.$i18n.locale === "br"
      ? _c("div", [
          _vm.$store.state.currentUser.user.rol !== "CLIENT"
            ? _c("div", { attrs: { id: "notPermissions" } }, [
                _c("p", [
                  _vm._v(
                    "Você não tem permissão para visualizar este menu. Consulte a equipe de desenvolvimento para mais informações."
                  ),
                ]),
              ])
            : _vm._e(),
        ])
      : _vm._e(),
    _vm.$i18n.locale === "cl"
      ? _c("div", [
          _vm.$store.state.currentUser.user.rol !== "CLIENT"
            ? _c("div", { attrs: { id: "notPermissions" } }, [
                _c("p", [
                  _vm._v(
                    "Usted no tiene permisos para ver este menú. Consulte al equipo de desarrollo para más información."
                  ),
                ]),
              ])
            : _vm._e(),
          _vm.$i18n.locale === "cl" &&
          _vm.$store.state.currentUser.user.rol === "CLIENT"
            ? _c(
                "div",
                { staticClass: "pay-here-content" },
                [
                  _c(
                    "div",
                    { staticClass: "steps-module-content" },
                    [_c("StepsBar", { attrs: { steps: _vm.steps } })],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "step-view" },
                    [
                      _c("router-view", {
                        on: {
                          enableNextButton: function ($event) {
                            _vm.enableNextButton = $event
                          },
                          enableBackButton: function ($event) {
                            _vm.enableBackButton = $event
                          },
                          sendNameNextStep: _vm.setNextStepName,
                          sendNameBackStep: _vm.setBackStepName,
                          "set-event-next": _vm.setEventNext,
                          setTransactionId: _vm.setTransactionId,
                          updateFooterButtons: _vm.updateFooterButtons,
                          "open-confirm-transaction-modal":
                            _vm.openConfirmTransactionModal,
                          "open-cancel-transaction-modal":
                            _vm.openCancelTransactionModal,
                          "confirm-deselect-payment":
                            _vm.confirmDeselectPayment,
                          "open-trusted-ids-modal": function ($event) {
                            _vm.isTrustedIdNumbersCardModalActive = true
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "footer-resume transition-slow",
                      class: { active: _vm.showFooter && _vm.transaction._id },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "button-content transition-slow",
                          class: {
                            hidden: !_vm.backStepName,
                            complete: !_vm.showNextButton,
                          },
                        },
                        [
                          _vm.backStepName !== ""
                            ? _c(
                                "button",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.showBackButton,
                                      expression: "showBackButton",
                                    },
                                  ],
                                  staticClass:
                                    "button is-button-secondary is-rounded",
                                  attrs: {
                                    id: "backButton",
                                    disabled: !_vm.enableBackButton,
                                  },
                                  on: { click: _vm.returnBack },
                                },
                                [_vm._v(" Atrás ")]
                              )
                            : _vm._e(),
                        ]
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "total-content",
                          attrs: { id: "total-amount-container" },
                        },
                        [
                          _c(
                            "p",
                            [
                              _vm._v(" Total a pagar: "),
                              _c("span", [
                                _vm._v(
                                  "$ " + _vm._s(_vm.transactionAmount) + " "
                                ),
                              ]),
                              _vm.usedClientBalance
                                ? _c(
                                    "b-tooltip",
                                    {
                                      attrs: {
                                        id: "total-details-tooltip",
                                        multilined: "",
                                        triggers: ["click", "hover"],
                                        position: "is-left",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "content",
                                            fn: function () {
                                              return [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "is-flex is-justify-content-space-between",
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "has-text-white",
                                                      },
                                                      [_vm._v("Cuotas: ")]
                                                    ),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "has-text-white",
                                                      },
                                                      [
                                                        _vm._v(
                                                          "$ " +
                                                            _vm._s(
                                                              _vm.transactionDebtAmount
                                                            )
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "is-flex is-justify-content-space-between",
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "has-text-white",
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Saldo utilizado: "
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "has-text-white",
                                                      },
                                                      [
                                                        _vm._v(
                                                          "$ " +
                                                            _vm._s(
                                                              _vm.usedClientBalance
                                                            )
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "is-flex is-justify-content-space-between has-text-weight-bold",
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "has-text-white",
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Total a pagar: "
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "has-text-white",
                                                      },
                                                      [
                                                        _vm._v(
                                                          "$ " +
                                                            _vm._s(
                                                              _vm.transactionAmount
                                                            )
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            },
                                            proxy: true,
                                          },
                                        ],
                                        null,
                                        false,
                                        2336630688
                                      ),
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "fas fa-info-circle",
                                        attrs: { id: "total-details" },
                                      }),
                                    ]
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ]
                      ),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.showNextButton,
                              expression: "showNextButton",
                            },
                          ],
                          staticClass: "button-content transition-slow",
                          class: _vm.backStepName !== "" ? "" : "complete",
                        },
                        [
                          _c(
                            "button",
                            {
                              staticClass:
                                "button is-button-primary is-rounded",
                              attrs: {
                                id: "continueButton",
                                disabled: !_vm.enableNextButton,
                              },
                              on: { click: _vm.continueNext },
                            },
                            [_vm._v(" " + _vm._s(_vm.nextButtonText) + " ")]
                          ),
                        ]
                      ),
                    ]
                  ),
                  _c(
                    "b-modal",
                    {
                      attrs: { width: 400 },
                      model: {
                        value: _vm.confirmingTransaction.isModalActive,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.confirmingTransaction,
                            "isModalActive",
                            $$v
                          )
                        },
                        expression: "confirmingTransaction.isModalActive",
                      },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "modal-card-body has-text-centered" },
                        [
                          _c("div", [
                            _c(
                              "a",
                              {
                                staticClass: "close-modal",
                                on: {
                                  click: function ($event) {
                                    _vm.confirmingTransaction.isModalActive = false
                                  },
                                },
                              },
                              [
                                _c("img", {
                                  attrs: {
                                    src: require("@/ui/assets/img/plus-button.svg"),
                                  },
                                }),
                              ]
                            ),
                          ]),
                          _c("h3", { staticClass: "modal-title" }, [
                            _vm._v("¡Último paso!"),
                          ]),
                          _c("p", { staticClass: "modal-content" }, [
                            _vm._v(
                              " Presiona el botón e iniciaremos la validación de tu pago (te notificaremos a tu mail si todo esta ok) "
                            ),
                          ]),
                          _c("p", { staticClass: "modal-footer" }, [
                            _vm._v(
                              "El proceso de validación puede tomar hasta 24 hrs hábiles"
                            ),
                          ]),
                          _c(
                            "button",
                            {
                              staticClass:
                                "button is-button-primary is-rounded",
                              attrs: { id: "button-create-transaction" },
                              on: {
                                click: function ($event) {
                                  return _vm.$emit("create-transaction")
                                },
                              },
                            },
                            [_vm._v(" Validar mi pago ")]
                          ),
                        ]
                      ),
                    ]
                  ),
                  _c(
                    "b-modal",
                    {
                      attrs: { width: 600 },
                      model: {
                        value: _vm.cancellingRelatedTransaction.isModalActive,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.cancellingRelatedTransaction,
                            "isModalActive",
                            $$v
                          )
                        },
                        expression:
                          "cancellingRelatedTransaction.isModalActive",
                      },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "modal-card-body has-text-centered" },
                        [
                          _c("div", { staticClass: "modal-card-header" }, [
                            _c("div", { staticClass: "is-pulled-right" }, [
                              _c(
                                "a",
                                {
                                  staticClass: "close-modal",
                                  on: {
                                    click: function ($event) {
                                      _vm.cancellingRelatedTransaction.isModalActive = false
                                    },
                                  },
                                },
                                [
                                  _c("img", {
                                    attrs: {
                                      src: require("@/ui/assets/img/plus-button.svg"),
                                    },
                                  }),
                                ]
                              ),
                            ]),
                            _c("h3", { staticClass: "modal-title" }, [
                              _vm._v("Anular Pago"),
                            ]),
                          ]),
                          _c("section", { staticClass: "modal-card-body" }, [
                            _c("p", [
                              _vm._v(
                                ' Al hacer click en "Anular Pago", se descartará el pago creado y las cuotas volverán a estar disponibles para ser pagadas. Si realizaste una transacción, será necesario que vuelvas a hacer el proceso de pago para que sea validada. '
                              ),
                            ]),
                            _c("div", { staticClass: "confirmation-buttons" }, [
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "button is-button-secondary is-rounded",
                                  attrs: { id: "cancel-transaction-anulation" },
                                  on: {
                                    click: function ($event) {
                                      _vm.cancellingRelatedTransaction.isModalActive = false
                                    },
                                  },
                                },
                                [_vm._v(" Volver ")]
                              ),
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "button is-button-primary is-rounded",
                                  attrs: {
                                    id: "anulate-transaction",
                                    disabled:
                                      _vm.cancellingRelatedTransaction
                                        .disabledCancelButton,
                                  },
                                  on: { click: _vm.cancelCurrentTransaction },
                                },
                                [_vm._v(" Anular Pago ")]
                              ),
                            ]),
                          ]),
                        ]
                      ),
                    ]
                  ),
                  _c(
                    "b-modal",
                    {
                      attrs: { width: 600 },
                      model: {
                        value: _vm.confirmSelection.isModalActive,
                        callback: function ($$v) {
                          _vm.$set(_vm.confirmSelection, "isModalActive", $$v)
                        },
                        expression: "confirmSelection.isModalActive",
                      },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "modal-card-body has-text-centered" },
                        [
                          _c("div", { staticClass: "modal-card-header" }, [
                            _c("div", { staticClass: "is-pulled-right" }, [
                              _c(
                                "a",
                                {
                                  staticClass: "close-modal",
                                  on: {
                                    click: function ($event) {
                                      _vm.confirmSelection.isModalActive = false
                                    },
                                  },
                                },
                                [
                                  _c("img", {
                                    attrs: {
                                      src: require("@/ui/assets/img/plus-button.svg"),
                                    },
                                  }),
                                ]
                              ),
                            ]),
                            _c("h3", { staticClass: "modal-title" }, [
                              _c("span", { staticClass: "modal-alert-title" }, [
                                _vm._v("Alerta"),
                              ]),
                              _c("br"),
                              _vm._v(
                                " ¿De verdad quieres dejar impaga una de tus cuotas de este mes? "
                              ),
                            ]),
                          ]),
                          _c("section", { staticClass: "modal-card-body" }, [
                            _c("p", [
                              _vm._v(
                                " Podrías caer en mora, generando intereses penales y cobros adicionales (según la Ley del Consumidor - Nº 19.496). "
                              ),
                            ]),
                            _c("div", { staticClass: "confirmation-buttons" }, [
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "button is-button-secondary is-rounded",
                                  attrs: { id: "anulate-transaction" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.emitCheckboxEvent(
                                        _vm.confirmSelection.event
                                      )
                                    },
                                  },
                                },
                                [_vm._v(" Dejar una impaga ")]
                              ),
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "button is-button-primary is-rounded",
                                  attrs: { id: "cancel-transaction-anulation" },
                                  on: {
                                    click: function ($event) {
                                      _vm.confirmSelection.isModalActive = false
                                    },
                                  },
                                },
                                [_vm._v(" Mejor pagar las dos ")]
                              ),
                            ]),
                          ]),
                        ]
                      ),
                    ]
                  ),
                  _c(
                    "b-modal",
                    {
                      attrs: { scroll: "keep" },
                      model: {
                        value: _vm.isTrustedIdNumbersCardModalActive,
                        callback: function ($$v) {
                          _vm.isTrustedIdNumbersCardModalActive = $$v
                        },
                        expression: "isTrustedIdNumbersCardModalActive",
                      },
                    },
                    [
                      _c("trusted-id-numbers", {
                        on: {
                          "is-modal-active": function ($event) {
                            _vm.isTrustedIdNumbersCardModalActive = $event
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }